export default "__VITE_ASSET__HBBgp8Yb__"